import { render, staticRenderFns } from "./CreateShoppingCartDppOfferComponent.vue?vue&type=template&id=b345b24e&"
import script from "./CreateShoppingCartDppOfferComponent.vue?vue&type=script&lang=js&"
export * from "./CreateShoppingCartDppOfferComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports